import {
  CreateClientNameRequest,
  ClientNameGetDto,
  UpdateClientNameRequest,
  EmptyResponse,
  Error,
  OptionItemDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class ClientNamesService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateClientNameRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<ClientNameGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/client-names';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<ClientNameGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/client-names/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateClientNameRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<ClientNameGetDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/client-names/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/client-names/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getOptions(
    params: {
      /**  */
      value?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<OptionItemDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/client-names/options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { value: params['value'] };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
